import { useGetTracking } from '@application/Interfaces/Hooks/useGetTracking'
import { Nullable } from '@src/Application/Types/Opt'
import { dateLocalTimeFormatter } from '@src/Application/Utils/DateUtils'
import { GetTrackAndTraceError, TrackAndTraceEvent } from '@src/Infrastructure/Types/GetTrackAndTrace'

export const fetchData = async ({
    refetch,
    setEvents,
    setError,
}: {
    refetch: ReturnType<typeof useGetTracking>['refetch']
    setEvents: (events: Nullable<TrackAndTraceEvent[]>) => void
    setError: (error: GetTrackAndTraceError) => void
}): Promise<void> => {
    const { data, isError, isLoading, error } = await refetch()

    if (isError && !isLoading) {
        setError(error.code)
    }
    if (!isLoading && !isError && data) {
        setEvents(data?.data)
    }
}

export const mapTrackingEventToShipmentActivity = (
    events?: Nullable<TrackAndTraceEvent[]>
): { date: string; time: string; event: string; location: string }[] => {
    if (!events) return []

    return events.map((event) => ({
        date: dateLocalTimeFormatter(event.occuredAtLocal),
        time: dateLocalTimeFormatter(event.occuredAtLocal, 'HH:mm'),
        event: event.category,
        location: event.location || '',
    }))
}

export const handleValueChange =
    (setValue: (value: string) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value

        setValue(value)
    }

export const handleSubmit = (value: string, setShipmentId: (value: string) => void) => (): void => {
    setShipmentId(value)
}
